import React from "react";
import { Routes, Route } from "react-router-dom";
import { hasPermission } from "../utils/permissionUtils";
import Products from "../pages/Pawn/Products/AllProduct";
import BorrowItems from "../pages/Pawn/Products/BorrowItems";
import BuyItems from "../pages/Pawn/Products/BuyItems";
import OverdueBorrowItems from "../pages/Pawn/Products/OverdueBorrowItems";
import OverduePawnItems from "../pages/Pawn/Products/OverduePawnItems";
import ReadyItems from "../pages/Pawn/Products/ReadyItems";
import SoldItems from "../pages/Pawn/Products/SoldItems";
import SellOnConsignmen from "../pages/Pawn/List/SellOnConsignmen";
// import ListByCustomer from "../pages/Pawn/List/ListByCustomer";
import ListByCustomerCar from "../pages/Car/List/ListByCustomerCar";
import RedemptionItems from "../pages/Pawn/List/RedemptionItems";
// import SettingPrice from "../pages/Pawn/List/SettingPrice";
import Inventory from "../pages/Pawn/Report/Inventory";
import IncomeExpenes from "../pages/Pawn/Report/IncomeExpenses";
import Interest from "../pages/Pawn/Report/Interest";
import ImportData from "../pages/Pawn/ImportRetrospectiveData/ImportData";
import ImportInformationBuy from "../pages/Pawn/ImportRetrospectiveData/ImportInformationPawn";
import ImportInformationPawn from "../pages/Pawn/ImportRetrospectiveData/ImportInformationBuy";
import ImportList from "../pages/Pawn/ImportRetrospectiveData/ImportList";
import Dashboard from "../pages/Dashboard";
import BuyCars from "pages/Car/Products/BuyCars";
import ReadyCarsForSale from "pages/Car/Products/ReadyCars";
import FormBuyCars from "pages/Car/Products/BuyCars/form";
import ConsignmentCars from "pages/Car/List/ConsignmentCars";
import FormConsignmentCars from "pages/Car/List/ConsignmentCars/form";
import PawnCars from "pages/Car/List/PawnCars";
import SoldCars from "pages/Car/Products/SoldCars";
import BinCars from "pages/Car/List/Bin";
import CustomersCar from "pages/Car/List/Customers";
import DocumentsList from "pages/Car/List/Doucments";
import PreviewForms from "pages/Car/List/Doucments/preview";
import RedeemCars from "pages/Car/List/Redeem.js";
import RepossessedCars from "pages/Car/List/Repossessed";
import AllCars from "pages/Car/Products/AllCars";
import FormReadySellCar from "pages/Car/Products/ReadyCars/form";
import FormPawnCars from "pages/Car/List/PawnCars/form";
import InventoryCars from "pages/Car/Report/Inventory";
import IncomeExpensesCar from "pages/Car/Report/IncomeExpenses";
import InterestCars from "pages/Car/Report/Interest";

const CarRoutes = ({ role }) => {
  return (
    <Routes>
      <Route path="dashboard_cars" element={<Dashboard />} />
      {hasPermission(role, ["admin", "owner", "AdminA", "AdminM"]) && (
        <>
          <Route path="all_cars" element={<AllCars />} />
          <Route path="buy_cars" element={<BuyCars />} />
          <Route path="buy_cars/form/:id" element={<FormBuyCars />} />
          <Route path="ready_cars" element={<ReadyCarsForSale />} />
          <Route path="ready_cars/form/:id" element={<FormReadySellCar />} />
          <Route path="borrow_cars" element={<BorrowItems />} />
          <Route path="overdue_borrow_cars" element={<OverdueBorrowItems />} />
          <Route path="sold_cars" element={<SoldCars />} />
          {/* <Route path="overdue_pawn_cars" element={<OverduePawnItems />} /> */}
        </>
      )}

      {hasPermission(role, ["admin", "owner", "AdminA", "AdminM"]) && (
        <>
          <Route path="pawn_cars" element={<PawnCars />} />
          <Route path="pawn_cars/form/:id" element={<FormPawnCars />} />
          <Route path="consignment_cars" element={<ConsignmentCars />} />
          <Route
            path="consignment_cars/form/:id"
            element={<FormConsignmentCars />}
          />
          <Route path="redemption_cars" element={<RedeemCars />} />
          <Route path="repossessed_cars" element={<RepossessedCars />} />
          <Route path="list_by_customer_cars" element={<ListByCustomerCar />} />
          <Route path="bin_cars" element={<BinCars />} />
          <Route path="customer_list_cars" element={<CustomersCar />} />
          <Route path="documents" element={<DocumentsList />} />
          <Route path="/documents/preview/:id" element={<PreviewForms />} />
        </>
      )}

      {hasPermission(role, ["admin", "owner", "AdminA", "AdminM"]) && (
        <>
          <Route path="inventory_cars" element={<InventoryCars />} />
          <Route path="income_expenses_cars" element={<IncomeExpensesCar />} />
          <Route path="interest_cars" element={<InterestCars />} />
        </>
      )}

      {hasPermission(role, ["admin", "owner", "AdminA", "AdminM"]) && (
        <>
          <Route path="import_data_cars" element={<ImportData />} />
          <Route
            path="import_information_cars"
            element={<ImportInformationPawn />}
          />
          <Route
            path="import_information_buy_cars"
            element={<ImportInformationBuy />}
          />
          <Route path="import_list_cars" element={<ImportList />} />
        </>
      )}
    </Routes>
  );
};

export default CarRoutes;
